// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/flag.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/flag'

import { Icon, type IconComponentProps } from '../icon'

export const FlagIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
